import { IWorkoutMinutes } from 'fitbeat.models';
import { IUserWorkoutStatsRepository } from '../interfaces';
import { PouchDbQueryHelper } from './pouchdb-query-helper';
export class DbUserWorkoutStatsRepository implements IUserWorkoutStatsRepository {

    private db: PouchDbQueryHelper;

    constructor(private gymStateDb: any) {
        this.db = new PouchDbQueryHelper(this.gymStateDb, 'DbUserWorkoutStatsRepository');
    }

    public async getUserWorkoutStats(uid: string, startYear: number, startMonth: number,
                                     endYear: number, endMonth: number)
        : Promise<Array<{ key: string | number[]; value: number }>> {
        return await this.db.queryView('total-workouts-stats/total-workouts', {
            startkey: [uid, startYear, startMonth],
            endkey: [uid, endYear, endMonth, {}],
            group: true,
            group_level: 4,
        });
    }

    public async getUserMinutesPerForkout(uid: string, startTime: number, endTime: number)
        : Promise<IWorkoutMinutes[]> {
        const workoutViewResult = await this.db.queryView('total-minutes-per-workout/total-minutes-per-workout', {
            startkey: [uid, startTime],
            endkey: [uid, endTime, {}],
        });
        return workoutViewResult.map((value) => {
            return {
                totalMinutes: value.value,
                startTime: value.key[1],
                endTime: value.key[2],
                workoutType: value.key[3],
                load: value.key[4],
            };
        });
    }
}
